import { ChangeDetectionStrategy, Component, computed, inject, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppContext } from 'src/app/app/context';
import { IsNotificationSectionEnabled } from '../../../notifications/notification-handler.service';
import { AssetLockDto, AssetLockService, NotificationCategory, NotificationService } from '../../../services/api.services';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { AssetTypes } from '../../guards/asset-lock-guard';

@Component({
  selector: 'app-unlock-notification-dialog',
  templateUrl: './unlock-notification-dialog.component.html',
  styleUrls: ['./unlock-notification-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnlockNotificationDialogComponent {
  static readonly defaults = {
    width: '450px',
    height: '250px',
    closeOnNavigation: true,
  };

  readonly appContext = inject(AppContext);

  readonly lockDto = signal<AssetLockDto>(null);

  readonly lockedBy = computed(() => this.lockDto()?.lockedBy);

  readonly contentName = computed(() => this.lockDto()?.contentName);

  readonly contentTypeName = computed(() => {
    switch (this.lockDto()?.contentTypeName) {
      case AssetTypes.Visual: return 'Visual';
      case AssetTypes.Dashboard: return 'Dashboard';
      case AssetTypes.Schedule: return 'Schedule';
      case AssetTypes.PublishedReport: return 'Published Item';
    }
  });

  readonly showNotificationButton = computed(() => {
    return !!IsNotificationSectionEnabled(
      this.appContext.settings()?.notificationSettings,
      NotificationCategory.Unlocked
    )?.enabled;
  });

  constructor(
    public dialogRef: MatDialogRef<UnlockNotificationDialogComponent>,
    public assetLockService: AssetLockService,
    @Inject(MAT_DIALOG_DATA) public data: AssetLockDto) {
    this.dialogRef.addPanelClass('settings-modal-dialog-panel');

    this.lockDto.set(this.data);
  }

  addNotification() {
    this.assetLockService
      .enableUserNotification(this.data.contentTypeName, this.data.contentId)
      .subscribe(() => this.dialogRef.close());
  }

  close(): void {
    this.dialogRef.close();
  }
}
